const Images = {
  divyaDutta: require("../assets/divya-dutta.webp"),
  avantikaBVideo: require("../assets/export-videos/expert-avantika-bahuguna.webp"),
  LogoHeader: require("../assets/images/logo-top.png"),
  LogoHeaderV2: require("../assets/images/logo-top-v2.jpg"),
  LogoHeaderV3: require("../assets/images/logo-top-v3.png"),
  BannerRightBack: require("../assets/images/banner-right-back.png"),
  Com: require("../assets/images/com.png"),
  DarkCom: require("../assets/images/DarkCom.png"),
  GreenLeaf: require("../assets/images/green-leaf.svg"),
  OrangeLeaf: require("../assets/images/orange-leaf.svg"),
  LightGreenLeaf: require("../assets/images/light-green-leaf.png"),
  LightOrangeLeaf: require("../assets/images/light-orange-leaf.png"),
  MaskAnother: require("../assets/images/MaskAnother.png"),
  MaskBanner: require("../assets/images/Mask-banner.png"),
  MidBanner: require("../assets/soyf-reg-banner@lg.webp"),
  MidBannerM: require("../assets/soyf-reg-banner@sm.webp"),
  MidBannerD: require("../assets/images/mid-banner-m.jpg"),
  MidBg: require("../assets/images/mid-bg.png"),
  MidComIcon: require("../assets/images/mid-com-icon.png"),
  MidComIcon2: require("../assets/images/mid-com-icon2.png"),
  ScrollDown: require("../assets/images/scroll-down.png"),
  BannerLeft: require("../assets/images/banner-left.png"),
  DropDownArrow: require("../assets/images/dropDownArrow.png"),
  UploadFile: require("../assets/images/UploadFile.png"),
  UploadingFile: require("../assets/images/UploadingFile.png"),
  sliderProfileImg: require("../assets/images/sliderProfileImg.png"),
  BannerTopImg: require("../assets/images/Banner-top-img.png"),
  BannerBottomImg: require("../assets/images/Banner-bottom-img.png"),
  Cancel: require("../assets/images/cancel.png"),
  SuccessChecked: require("../assets/images/checked.png"),
  kirtImg: require("../assets/images/sliderProfileImgkirtisir.png"),
  MaliniImg: require("../assets/images/sliderProfileImgMalini.png"),
  RuchitaImg: require("../assets/images/sliderProfileImgRuchita.png"),
  SHINYDOSHIImg: require("../assets/images/sliderProfileImgSHINYDOSHI.png"),
  SussanneKhan: require("../assets/images/sussanne-khan.jpeg"),
  ManyaSingh: require("../assets/images/manya-singh.jpg"),
  MsChristina: require("../assets/images/MsChristina.jpeg"),
  MsNayantara: require("../assets/images/MsNayantara.jpeg"),
  MsVidhyaJoshi: require("../assets/images/MsVidhyaJoshi.jpeg"),
  PlayWhiteBanner: require("../assets/images/PlayWhiteBanner.png"),
  SalimMerchant: require("../assets/images/SalimMerchant.jpg"),
  ShinyDoshi: require("../assets/images/ShinyDoshi.jpg"),
  SejalJain: require("../assets/images/SejalJain.jpg"),
  SaiLokur: require("../assets/images/SaiLokur.jpg"),
  AshAmbawat: require("../assets/images/AshAmbawat.jpg"),
  RamShroff: require("../assets/images/ram-sir.webp"),
  sliderProfileImgMaliniNew: require("../assets/images/salim-merchant.png"),
  malini_agarwal_video_post_thumbnail: require("../assets/images/malini_agarwal.png"),
  ruchita_shah_thumbnail: require("../assets/images/ruchita_shah.png"),
  deeksha_panday_thumbnail: require("../assets/images/Deeksha-Pandey.jpeg"),
  gayatri_varun_thumbnail: require("../assets/images/gayatri-varun.jpeg"),
  sagarik_thumnail: require("../assets/images/sagarika.JPG"),
  naila_thumnail: require("../assets/images/naila-agrewal.jpeg"),
  soha_thumnail: require("../assets/images/soha-ali-khan.jpg"),
  CrossNewData: require("../assets/images/CrossNewData.png"),
  UploadNewData: require("../assets/images/UploadNewData.png"),
  glimps1: require("../assets/images/glimps-1.webp"),
  glimps2: require("../assets/images/glimps-2.webp"),
  glimps3: require("../assets/images/glimps-3.webp"),
  glimps4: require("../assets/images/glimps-4.webp"),
  glimps5: require("../assets/images/glimps-5.webp"),
  glimps6: require("../assets/images/glimps-6.webp"),
  glimps7: require("../assets/images/glimps-7.webp"),
};

export default Images;
